import { useTranslation } from 'react-i18next';

import { Badge } from '../../components/Badge';
import { formatDateTime } from '../../i18n';
import { useDuplicateCandidates } from './queries';

/**
 * Moegliche Duplikate waehrend der Erfassung -- F1-28, K-24.
 *
 * **Sie blockieren nichts.** Ein Ticket, das wie ein Duplikat aussieht, kann
 * eine zweite Stoerung derselben Art sein -- am Montagmorgen melden fuenf
 * Leute denselben Ausfall, und jeder von ihnen hat recht. Das zu entscheiden
 * ist Sache des Bearbeiters; diese Liste stellt ihm die Frage und beantwortet
 * sie nicht.
 *
 * **Sie bleibt still, wenn sie nichts hat.** Kein "keine Treffer" -- das
 * waere Laerm in einer Maske, die in wenigen Sekunden ausgefuellt werden
 * soll.
 */
export function DuplicateHints({ title }: { title: string }) {
  const { t, i18n } = useTranslation();
  const candidates = useDuplicateCandidates(title);

  if (!candidates.data || candidates.data.length === 0) {
    return null;
  }

  return (
    <section className="card" aria-label={t('tickets.duplicates')}>
      <h2>{t('tickets.duplicates')}</h2>
      <p className="table__muted">{t('tickets.duplicatesHint')}</p>

      <ul className="stack">
        {candidates.data.map((candidate) => (
          <li key={candidate.id}>
            <span className="table__number">{candidate.ticket_number}</span>{' '}
            <span className="table__subject">{candidate.title}</span>{' '}
            <Badge tone="neutral">{candidate.state.name}</Badge>
            <div className="table__muted">
              {formatDateTime(candidate.created_at, i18n.language)}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
